export default "__VITE_ASSET__1b8fce8e__"